module.exports = __webpack_public_path__ + "img/notification.03d92bee.png";